import { render, staticRenderFns } from "./ProductGrid.vue?vue&type=template&id=6c74bf75&scoped=true&"
import script from "./ProductGrid.vue?vue&type=script&lang=ts&"
export * from "./ProductGrid.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGrid.vue?vue&type=style&index=0&id=6c74bf75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c74bf75",
  null
  
)

export default component.exports